import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    * {
        box-sizing: border-box;
    }

    body {
        background: ${({ theme }) => theme.background};
        color:  ${({ theme }) => theme.textColor};
        margin: 0;
        padding: 0;
        transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        font-family: 'Inter', system-ui, -apple-system, sans-serif;    
        overflow-x: hidden;
    }

    .canvas {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 100vh;
        gap: 1rem;
        padding: 1rem 5%;
        width: 100vw;
        align-items: center;
        text-align: center;
        max-width: 1400px;
        margin: 0 auto;
    }

    .type-box {
        display: flex;
        flex-direction: column;
        width: 100%;
        min-height: 160px;
        margin: 0 auto;
        padding: 2rem;
        border-radius: 16px;
        background: rgba(255, 255, 255, 0.03);
        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.05);
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.05);
        overflow: hidden;
    }

    .upper-menu {
        margin-bottom: 1rem;
    }

    .words {
        font-size: 1.8rem;
        line-height: 1.5;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        color: ${({ theme }) => theme.typeBoxText};
        font-family: 'Fira Code', 'Roboto Mono', monospace;
    }

    .word {
        margin: 5px;
        padding-right: 2px;
    }

    .hidden-input {
        opacity: 0;
    }

    .current {
        border-left: 1px solid;
        animation: blinking 2s infinite;
        animation-timing-function: ease;

        @keyframes blinking {
            0% {border-left-color: white}
            25% {border-left-color: black}
            50% {border-left-color: white}
            75% {border-left-color: black}
            100% {border-left-color: white}
        }
    }

    .current-right {
        border-right: 1px solid;
        animation: blinkingRight 2s infinite;
        animation-timing-function: ease;

        @keyframes blinkingRight {
            0% {border-right-color: white}
            25% {border-right-color: black}
            50% {border-right-color: white}
            75% {border-right-color: black}
            100% {border-right-color: white}
        }
    }

    .correct {
        color: green;
    }

    .incorrect {
        color: red;
    }

    .upper-menu {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        padding: 1rem ;
        background: rgba(255, 255, 255, 0.02);
        backdrop-filter: blur(10px);
        border-radius: 20px;
        border: 1px solid ${({ theme }) => theme.typeBoxText}20;
        margin-bottom: 2rem;
    }

    .left-menu, .right-menu {
        display: flex;
        align-items: center;
        gap: 1.5rem;
    }

    .center-menu {
        display: flex;
        align-items: center;
        gap: 2rem;
        background: rgba(0,0,0,0.05);
        padding: 0.5rem 1.5rem;
        border-radius: 50px;
    }

    .modes-group {
        display: flex;
        gap: 1rem;
    }

    .mode-icon {
        padding: 8px;
        border-radius: 12px;
        transition: all 0.3s ease;
        cursor: pointer;
        opacity: 0.5;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .mode-icon:hover {
        opacity: 0.8;
        background: rgba(255,255,255,0.05);
    }

    .mode-icon.active {
        opacity: 1;
        background: ${({ theme }) => theme.typeBoxText};
        color: ${({ theme }) => theme.background};
        box-shadow: 0 4px 12px ${({ theme }) => theme.typeBoxText}40;
    }

    .separator {
        width: 2px;
        height: 25px;
        background: ${({ theme }) => theme.typeBoxText}30;
    }

    .sub-modes {
        display: flex;
        gap: 1.5rem;
    }

    .time-modes {
        display: flex;
        gap: 1rem;
    }

    .sub-mode {
        font-size: 1rem;
        font-weight: 700;
        cursor: pointer;
        opacity: 0.4;
        transition: all 0.2s ease;
        padding: 4px 8px;
        border-radius: 8px;
    }

    .sub-mode.active {
        opacity: 1;
        color: ${({ theme }) => theme.typeBoxText};
    }

    .sub-mode:hover {
        opacity: 0.8;
    }

    .difficulty-toggle {
        padding: 8px 15px;
        border-radius: 12px;
        border: 1px solid ${({ theme }) => theme.typeBoxText}40;
        transition: all 0.3s ease;
        color: ${({ theme }) => theme.typeBoxText};
        opacity: 0.6;
    }

    .difficulty-toggle.active {
        opacity: 1;
        background: #ff4d4d20;
        border-color: #ff4d4d;
        color: #ff4d4d;
        box-shadow: 0 0 15px #ff4d4d30;
    }

    .counter {
        font-size: 2rem;
        display: flex;
        align-items: center;
        gap: 2rem;
    }

    .reload-btn {
        width: fit-content;
        margin: 2rem auto 0;
        cursor: pointer;
        background: ${({ theme }) => theme.typeBoxText};
        border-radius: 50%;
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0 4px 15px rgba(0,0,0,0.1);
        color: ${({ theme }) => theme.background};
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .reload-btn:hover {
        transform: rotate(180deg) scale(1.1);
        box-shadow: 0 6px 20px rgba(0,0,0,0.15);
    }

    .modes {
        display: flex;
        justify-content: space-between;
        gap: 1rem;
    }

    .time-mode {
        padding: 0.5rem 1rem;
        border-radius: 20px;
        transition: all 0.2s ease;
        opacity: 0.7;
    }

    .time-mode:hover, .time-mode.active-mode {
        cursor: pointer;
        opacity: 1;
        background: ${({ theme }) => theme.typeBoxText};
        color: ${({ theme }) => theme.background};
        transform: scale(1.05);
    }

    .footer {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin: 0 auto;
        padding: 1rem 0;
        align-items: center;
    }

    .themeButton {
        display: flex;
        align-items: center;
        gap: 1rem;
        width: fit-content;
    }

    .heading {
        color: ${({ theme }) => theme.typeBoxText};
        font-weight: 600;
        border-top: 1.5px solid;
        border-bottom: 1.5px solid;
        padding: 0.2rem;
    }

    .stats-box {
        display: flex;
        width: 100%;
        height: auto;
        margin-right: auto;
        margin-left: auto;
    }

    .left-stats {
        width: 30%;
        padding: 30px;
        display: flex;
        flex-direction: column;
    }

    .right-stats {
        width: 70%
    }

    .title {
        font-size: 18px;
        color: ${({ theme }) => theme.textColor};
        opacity: 0.6;
        display: flex;
        border-bottom: 1px solid;
        margin-bottom: 0.5rem;
    }

    .subtitle {
        font-size: 30px;
        display: flex;
        align-items: center;
        gap: 1rem;
        color: ${({ theme }) => theme.typeBoxText}
    }

    .chars {
        font-size: 20px;
        color: ${({ theme }) => theme.typeBoxText};
        text-align: left;
        border-bottom: 1px solid ${({ theme }) => theme.textColor};
        padding-bottom: 0.4rem;
        opacity: 0.8;
    }

    .again {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .again:hover {
        transform: scale(1.4);
        transition: transform 0.5s ease-in-out;
    }

    .header {
        width: 100%;
        margin-top: 0;
        margin-right: auto;
        margin-left: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem;
        padding: 0
    }

    .user-and-logout {
        display: flex;
        gap: 1rem;
    }

    .logo {
        transition: transform ease-in-out 0.7s;
    }

    .logo img {
        padding: 0;
        width: 150px;
        filter: drop-shadow(5px 5px 5px #000000)
    }

    .tagline {
        margin-top: -35px;
        font-family: 'Square Peg', cursive;
        font-size: 2rem;
        font-weight: 1000;
        letter-spacing: 0.2rem;
        color: ${({ theme }) => theme.typeBoxText};
    }


    .modal  {
        display: flex;
        justify-content: center;
        align-items: center;
        backdrop-filter: blur(3px);
    }

    .modal-content {
        width: 400px;
        border: 1px solid ${({ theme }) => theme.typeBoxText};
        padding: 0.3rem;
        border-radius: 10px;
        box-shadow: rgba(0, 0, 0, 0.56) 0px 22px 70px 4px;
        background: ${({ theme }) => theme.background};
        text-align: center;
    }

    .appBar {
        background: transparent;
        border-radius: 7px;
    }

    .login-form {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
   
    .btn {
        color: ${({ theme }) => theme.background};
        font-weight: bold;
        background:  ${({ theme }) => theme.typeBoxText};
        border: none;
        border-radius: 12px;
        transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        text-transform: capitalize;
        padding: 12px 0;
        margin-top: 1rem;
        box-shadow: 0 4px 15px rgba(255, 123, 0, 0.2);
    }

    .btn:hover {
        background: ${({ theme }) => theme.typeBoxText};
        opacity: 0.9;
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(255, 123, 0, 0.3);
    }

    .btn:focus {
        outline: none;
    }

    .toast-message {
        border-radius: 12px;
        color: ${({ theme }) => theme.textColor};
        background: ${({ theme }) => theme.background};
        border: 1px solid ${({ theme }) => theme.typeBoxText};
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(10px);
        font-family: 'Inter', sans-serif;
        font-weight: 600;
        padding: 5px;
    }

    .google-btn {
        width: 100%;
        margin: 1rem auto;
    }

    .table, .graph-user-page {
        margin: auto;
        width: 100%;
    }

    .table {
        margin: 2rem 0;
        width: 100%;
        border-radius: 16px;
        overflow: hidden;
        border: 1px solid ${({ theme }) => theme.typeBoxText}20;
    }

    .graph-user-page {
        margin-bottom: 2rem;
    }


    .table th {
        color: ${({ theme }) => theme.textColor} !important;
        background-color: ${({ theme }) => theme.background} !important;
        border-bottom: 2px solid ${({ theme }) => theme.typeBoxText} !important;
        text-align: center;
        font-weight: 800;
        font-size: 1.1rem;
        z-index: 10;
    }

    .table td {
        color: ${({ theme }) => theme.typeBoxText};
        text-align: center;
    }

    .user-profile{
        width: 100%;
        margin: auto;
        margin-bottom: 2rem;
        display: flex;
        padding: 1rem 0;
        background: rgba(255, 255, 255, 0.7);
        color: black;
        border-radius: 20px;
        justify-content: space-around;
        align-items: center;
        box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;
    }
    .user{
        width: 60%;
        display: flex;
        align-items: center;
        font-size: 1.1rem;
        border-right: 1px solid black;
    }
    .info{
        width: 60%;
        padding: 1rem 0;
        text-align: left;
    }
    .picture{
        width: 40%;
    }

    .total-tests {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }

    .back-to-homepage {
        text-decoration: none;
        color: ${({ theme }) => theme.textColor};        
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        background: ${({ theme }) => theme.background};
        border: 1px solid;
        border-radius: 11px;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;   
        padding: 0.4rem 0;
    }

    .back-to-homepage:hover {
        cursor: pointer;
        color: ${({ theme }) => theme.typeBoxText};
        box-shadow: rgba(0, 0, 0, 0.4) 0px 30px 90px;
        box-shadow: 0px 2px 5px ${({ theme }) => theme.typeBoxText};
    }

    .footer {
        padding: 0.3rem;
    }

    .center-of-screen {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        min-height: 100vh;
        justify-content: center;
        align-items: center;
        text-align: center;
    }

    .center-of-screen a {
        padding: 1rem;
    }

    .center-of-screen div {
        font-size: 1.5rem;
        font-weight: 600;
    }

    .motivation-quote {
        margin: 2rem auto;
        width: 100%;
        max-width: 900px;
        font-size: 1.4rem;
        font-weight: 500;
        font-style: italic;
        color: ${({ theme }) => theme.textColor};
        background: ${({ theme }) => theme.typeBoxText}10;
        border-left: 8px solid ${({ theme }) => theme.typeBoxText};
        border-radius: 16px;
        padding: 2rem;
        line-height: 1.6;
        box-shadow: 0 4px 20px rgba(0,0,0,0.05);
    }

    .motivation-quote b {
        color: ${({ theme }) => theme.typeBoxText};
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 1px;
        font-style: normal;
        display: block;
        margin-bottom: 0.5rem;
        font-size: 1rem;
    }
    
    .links {
        display: flex;
        gap: 0.7rem;
    }

    .links a {
        text-decoration: none;
        color: ${({ theme }) => theme.typeBoxText};
        &:hover{
            color: ${({ theme }) => theme.textColor};
        }
    }

    .results-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
        gap: 1.5rem;
        width: 100%;
        margin-top: 2rem;
    }

    .result-card {
        background: rgba(255, 255, 255, 0.05);
        backdrop-filter: blur(10px);
        border: 1px solid ${({ theme }) => theme.typeBoxText}20;
        border-radius: 16px;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        gap: 0.8rem;
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
    }

    .result-card:hover {
        transform: translateY(-3px);
        background: rgba(255, 255, 255, 0.08);
        border-color: ${({ theme }) => theme.typeBoxText}40;
    }

    .result-card::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 3px;
        height: 100%;
        background: ${({ theme }) => theme.typeBoxText};
    }

    .result-card .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .result-card .wpm-badge {
        font-size: 1.6rem;
        font-weight: 900;
        color: ${({ theme }) => theme.typeBoxText};
    }

    .result-card .acc-badge {
        font-weight: 700;
        font-size: 0.9rem;
        background: ${({ theme }) => theme.typeBoxText}15;
        color: ${({ theme }) => theme.typeBoxText};
        padding: 2px 10px;
        border-radius: 50px;
    }

    .result-card .card-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.75rem;
        opacity: 0.5;
        margin-top: 0.2rem;
        border-top: 1px solid rgba(255,255,255,0.05);
        padding-top: 0.6rem;
    }


    .login-page-container {
        display: flex;
        flex-direction: row;
        height: 100vh;
        min-height: 100vh;
        width: 100%;
        overflow: hidden;
        background: ${({ theme }) => theme.background};
    }

    .login-card {
        max-width: 700px;
        padding: 2.5rem 3.5rem;
        border-radius: 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1.2rem;
        transition: transform 0.3s ease;
        background: rgba(255, 255, 255, 0.05); /* very light base */
    }

    .login-card:hover {
        transform: translateY(-5px);
    }

    .login-header {
        text-align: center;
        margin-bottom: 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
    }

    .toggle-buttons {
        display: flex;
        width: 100%;
        margin-bottom: 1rem;
        background: rgba(0,0,0,0.1);
        border-radius: 5rem;
        overflow: hidden;
    }
    
    .toggle-btn {
        flex: 1;
        padding: 0.7rem;
        border: none;
        cursor: pointer;
        font-weight: bold;
        transition: all 0.3s ease;
        font-size: 1.1rem;
    }

    .form-container {
        width: 100%;
    }

    .google-signin-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .or-divider {
        margin: 7px 0;
        font-weight: bold;
        opacity: 0.5;
        font-size: 0.9rem;
        letter-spacing: 2px;
    }

    .google-btn-custom {
        transition: transform 0.2s;
    }

    .google-btn-custom:hover {
        transform: scale(1.02);
    }

    .user-profile {
        backdrop-filter: blur(10px);
        background: rgba(255, 255, 255, 0.03);
        color: ${({ theme }) => theme.textColor};
    }

    // ─── Responsive Media Queries ─────────────────────────────────────

    @media (max-width: 1024px) {
        .canvas {
            padding: 1rem 3%;
        }

        .upper-menu {
            padding: 0.75rem 1rem;
        }

        .center-menu {
            gap: 1rem;
            padding: 0.5rem 1rem;
        }

        .stats-box {
            padding: 1rem;
        }
    }

    @media (max-width: 900px) {
        .canvas {
            padding: 1rem 2%;
            gap: 1rem;
        }

        .words {
            font-size: 1.4rem;
        }

        .upper-menu {
            flex-wrap: wrap;
            gap: 0.75rem;
            padding: 0.75rem;
            justify-content: center;
        }

        .left-menu {
            order: 1;
        }
        
        .center-menu {
            order: 2;
            flex-wrap: wrap;
            justify-content: center;
            width: 100%;
            gap: 0.5rem;
        }

        .right-menu {
            order: 3;
        }

        .stats-box {
            flex-direction: column;
        }

        .left-stats, .right-stats {
            width: 100%;
        }

        .table {
            width: 100%;
            overflow-x: auto;
        }

        /* Login page: stack on tablet */
        .login-page-container {
            flex-direction: column;
        }
    }

    @media (max-width: 600px) {
        * {
            font-size: 90%;
        }

        .canvas {
            padding: 0.75rem 1rem;
            gap: 0.75rem;
        }

        /* Header */
        .header {
            flex-wrap: wrap;
            gap: 0.5rem;
        }

        /* Upper menu – stack vertically */
        .upper-menu {
            flex-direction: column;
            gap: 0.5rem;
            padding: 0.75rem;
            margin-bottom: 1rem;
        }

        .left-menu, .center-menu, .right-menu {
            width: 100%;
            justify-content: center;
        }

        .center-menu {
            padding: 0.4rem 0.75rem;
        }

        .counter {
            font-size: 1.5rem;
            gap: 1rem;
        }

        /* Typing box */
        .words {
            font-size: 1.2rem;
            gap: 4px;
        }

        .type-box {
            padding: 1.25rem;
            min-height: 160px;
        }

        /* Footer */
        .footer {
            flex-direction: column-reverse;
            align-items: center;
            justify-content: center;
            gap: 1.5rem;
        }

        .themeButton {
            flex-direction: column;
            align-items: center;
        }

        /* Stats results */
        .stats-box {
            width: 100%;
            flex-direction: column-reverse;
            justify-content: center;
            align-items: center;
            padding: 0.5rem;
        }

        .left-stats {
            width: 100%;
            padding: 1rem;
        }

        .right-stats {
            width: 100%;
        }

        /* Leaderboard table */
        .table {
            width: 100%;
            overflow-x: auto;
        }

        .table th, .table td {
            font-size: 0.85rem;
            padding: 0.5rem;
        }

        /* Results grid */
        .results-grid {
            grid-template-columns: 1fr;
        }

        /* Motivation quote */
        .motivation-quote {
            font-size: 1.1rem;
            padding: 1rem 1.25rem;
        }

        /* Login page: full-width single column */
        .login-page-container {
            flex-direction: column !important;
            height: auto !important;
            min-height: 100vh;
            overflow-y: auto !important;
        }

        .toggle-buttons {
            margin-bottom: 0.5rem;
        }

        .toggle-btn {
            font-size: 0.95rem;
            padding: 0.6rem;
        }
    }
`;
